import React, { useRef, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { List, Empty, message, Skeleton, Form, Grid } from 'antd';
import { IMAGES, UPLOADS } from '../../params';
import { Link } from 'react-router-dom';
import { animateScroll as scroll } from 'react-scroll';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, Navigation, Autoplay } from 'swiper';
import { IoIosArrowDown } from "react-icons/io";
import 'swiper/swiper.min.css';
import "swiper/components/pagination/pagination.min.css";
import 'swiper/components/navigation/navigation.min.css';
SwiperCore.use([Autoplay, Navigation, Pagination]);

const { useBreakpoint } = Grid;

export const Hls = props => {
    const dispatch = useDispatch();

    const screens = useBreakpoint();
    const app_global = useSelector(state => state.app_global);

    const navigationPrevRef = React.useRef(null)
    const navigationNextRef = React.useRef(null)
    const [tabsActiveProperNutrition, setTabsActiveProperNutrition] = useState(false);
    const [tabsActivePhysicalActivity, setTabsActivePhysicalActivity] = useState(false);
    const [tabsActiveHealthySleep, setTabsActiveHealthySleep] = useState(false);

    const isInitialMount = useRef(true);

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;

            component_start();
        }
    }, []);

    async function component_start() {        
        
    }
    
    return (
        <section className='container_full --hls'>
            <section className='top'>
                <section className='container shadow default_padding'>
                    <h1>Здоровый образ жизни</h1>
                </section>
            </section>
            <section className='body'>
                <section className='container shadow default_padding'>
                    <div className='content'>
                        {app_global.loading ?
                            <Skeleton active />
                        :
                            <>
                                <div className='header'>
                                    <div className='posts_image_big'>
                                        <img src={`${IMAGES}/banners/hls_banner.jpeg`} />
                                    </div>
                                </div>
                                <div className='body'>
                                    <div className='text_content'>
                                    Сохранение здорового образа привносит в жизнь человека множество преимуществ. Оно способствует улучшению физического здоровья и психического самочувствия, увеличению продолжительности жизни, энергии и выносливости, а также общему улучшению качества жизни.
                                    </div>

                                    <div className='list_category'>
                                        <div className='list_item'>
                                            <div className='visible'>
                                                <img className='banner' src={`${IMAGES}/banners/hls_image_01.jpeg`} />
                                                <div className='right_info'>
                                                    <div className='info'>
                                                        <div className='title'>Правильное питание</div>
                                                        <div className='description'>Правильное питание играет ключевую роль в поддержании здоровья и благополучного состояния организма</div>
                                                    </div>
                                                    <div onClick={() => setTabsActiveProperNutrition(!tabsActiveProperNutrition)} className={`ant-btn ant-btn-primary default button_more ${tabsActiveProperNutrition ? 'active' : null}`} ><span>{tabsActiveProperNutrition ? 'Скрыть' : 'Подробнее'}</span><IoIosArrowDown /></div>
                                                </div>
                                            </div>
                                            {tabsActiveProperNutrition ?
                                                <div className='hidden'>
                                                    <div className='list'>
                                                        <Link className='posts_item' to={`/hls/1`} exact={ true } onClick={() => scroll.scrollToTop()}>
                                                            <div className='posts_item_top'>
                                                                <img src={`${IMAGES}/banners/hls_image_01_01.jpeg`} />
                                                            </div>
                                                            <div className={`posts_item_bottom`}>
                                                                <h2>Сбалансируйте свой рацион</h2>
                                                                <p className='excerpt'>Ваше тело нуждается в разнообразных питательных веществах, таких как белки, жиры, углеводы, витамины и минералы.</p>
                                                            </div>
                                                        </Link>
                                                        <Link className='posts_item' to={`/hls/2`} exact={ true } onClick={() => scroll.scrollToTop()}>
                                                            <div className='posts_item_top'>
                                                                <img src={`${IMAGES}/banners/hls_image_01_02.jpeg`} />
                                                            </div>
                                                            <div className={`posts_item_bottom`}>
                                                                <h2>Употребляйте свежие продукты</h2>
                                                                <p className='excerpt'>Свежие продукты богаты витаминами и минералами, и они могут помочь улучшить ваше здоровье</p>
                                                            </div>
                                                        </Link>
                                                        <Link className='posts_item' to={`/hls/3`} exact={ true } onClick={() => scroll.scrollToTop()}>
                                                            <div className='posts_item_top'>
                                                                <img src={`${IMAGES}/banners/hls_image_01_03.jpeg`} />
                                                            </div>
                                                            <div className={`posts_item_bottom`}>
                                                                <h2>Ограничьте потребление обработанных продуктов</h2>
                                                                <p className='excerpt'>Обработанные продукты стали неотъемлемой частью нашей современной жизни</p>
                                                            </div>
                                                        </Link>
                                                        <Link className='posts_item' to={`/hls/4`} exact={ true } onClick={() => scroll.scrollToTop()}>
                                                            <div className='posts_item_top'>
                                                                <img src={`${IMAGES}/banners/hls_image_01_04.jpeg`} />
                                                            </div>
                                                            <div className={`posts_item_bottom`}>
                                                                <h2>Потребляйте достаточно воды</h2>
                                                                <p className='excerpt'>Вода очень важна для вашего здоровья. Она помогает охлаждать ваше тело, удалять токсины и поддерживать работу органов.</p>
                                                            </div>
                                                        </Link>
                                                        <Link className='posts_item' to={`/hls/5`} exact={ true } onClick={() => scroll.scrollToTop()}>
                                                            <div className='posts_item_top'>
                                                                <img src={`${IMAGES}/banners/hls_image_01_05.jpeg`} />
                                                            </div>
                                                            <div className={`posts_item_bottom`}>
                                                                <h2>Избегайте переедания и закусок перед сном</h2>
                                                                <p className='excerpt'>Переедание может привести к перегрузке вашего желудка и снизить вашу энергию и продуктивность</p>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                </div>
                                            :
                                                null
                                            }
                                        </div>
                                        <div className='list_item'>
                                            <div className='visible'>
                                                <img className='banner' src={`${IMAGES}/banners/hls_image_02.jpeg`} />
                                                <div className='right_info'>
                                                    <div className='info'>
                                                        <div className='title'>Физическая активность</div>
                                                        <div className='description'>Физическая активность — это ключ к здоровому образу жизни</div>
                                                    </div>
                                                    <div onClick={() => setTabsActivePhysicalActivity(!tabsActivePhysicalActivity)} className={`ant-btn ant-btn-primary default button_more ${tabsActivePhysicalActivity ? 'active' : null}`} ><span>{tabsActivePhysicalActivity ? 'Скрыть' : 'Подробнее'}</span><IoIosArrowDown /></div>
                                                </div>
                                            </div>
                                            {tabsActivePhysicalActivity ?
                                                <div className='hidden'>
                                                    <div className='list'>
                                                        <Link className='posts_item' to={`/hls/6`} exact={ true } onClick={() => scroll.scrollToTop()}>
                                                            <div className='posts_item_top'>
                                                                <img src={`${IMAGES}/banners/hls_image_02_01.jpeg`} />
                                                            </div>
                                                            <div className={`posts_item_bottom`}>
                                                                <h2>Физическая активность</h2>
                                                                <p className='excerpt'>Простые способы, которые помогут улучшить фигуру, не напрягаясь</p>
                                                            </div>
                                                        </Link>
                                                        <Link className='posts_item' to={`/hls/7`} exact={ true } onClick={() => scroll.scrollToTop()}>
                                                            <div className='posts_item_top'>
                                                                <img src={`${IMAGES}/banners/hls_image_02_02.jpeg`} />
                                                            </div>
                                                            <div className={`posts_item_bottom`}>
                                                                <h2>Группы  мышц</h2>
                                                                <p className='excerpt'>Специальные упражнения для укрепления каждой группы мышц</p>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                </div>
                                            :
                                                null
                                            }
                                        </div>
                                        <div className='list_item'>
                                            <div className='visible'>
                                                <img className='banner' src={`${IMAGES}/banners/hls_image_03.jpeg`} />
                                                <div className='right_info'>
                                                    <div className='info'>
                                                        <div className='title'>Здоровый сон</div>
                                                        <div className='description'>Здоровый сон — это один из самых важных аспектов нашего здоровья</div>
                                                    </div>
                                                    <div onClick={() => setTabsActiveHealthySleep(!tabsActiveHealthySleep)} className={`ant-btn ant-btn-primary default button_more ${tabsActiveHealthySleep ? 'active' : null}`} ><span>{tabsActiveHealthySleep ? 'Скрыть' : 'Подробнее'}</span><IoIosArrowDown /></div>
                                                </div>
                                            </div>
                                            {tabsActiveHealthySleep ?
                                                <div className='hidden'>
                                                    <div className='list'>
                                                        <Link className='posts_item' to={`/hls/8`} exact={ true } onClick={() => scroll.scrollToTop()}>
                                                            <div className='posts_item_top'>
                                                                <img src={`${IMAGES}/banners/hls_image_04_01.jpeg`} />
                                                            </div>
                                                            <div className={`posts_item_bottom`}>
                                                                <h2>Фазы сна</h2>
                                                                <p className='excerpt'>Сон играет важную роль в восстановлении всего организма и снижении риска возникновения различных заболеваний.</p>
                                                            </div>
                                                        </Link>
                                                        <Link className='posts_item' to={`/hls/9`} exact={ true } onClick={() => scroll.scrollToTop()}>
                                                            <div className='posts_item_top'>
                                                                <img src={`${IMAGES}/banners/hls_image_04_02.jpeg`} />
                                                            </div>
                                                            <div className={`posts_item_bottom`}>
                                                                <h2>Дневник контроля сна</h2>
                                                                <p className='excerpt'>Ведение дневника самоконтроля поможет вам отследить свой график сна и улучшить его качество</p>
                                                            </div>
                                                        </Link>
                                                        <Link className='posts_item' to={`/hls/surveys`} exact={ true } onClick={() => scroll.scrollToTop()}>
                                                            <div className='posts_item_top'>
                                                                <img src={`${IMAGES}/banners/hls_image_04_03.jpeg`} />
                                                            </div>
                                                            <div className={`posts_item_bottom`}>
                                                                <h2>Тесты для улучшения качества сна</h2>
                                                                <p className='excerpt'>Пройдите тесты и узнайте, как избавиться от проблем со сном, определить свой тип сна и многое другое</p>
                                                            </div>
                                                        </Link>
                                                        <Link className='posts_item' to={`/hls/10`} exact={ true } onClick={() => scroll.scrollToTop()}>
                                                            <div className='posts_item_top'>
                                                                <img src={`${IMAGES}/banners/hls_image_04_04.jpeg`} />
                                                            </div>
                                                            <div className={`posts_item_bottom`}>
                                                                <h2>Йога для расслабления перед сном</h2>
                                                                <p className='excerpt'>Простые упражнения йоги, которые помогут вам расслабиться и улучшить качество сна</p>
                                                            </div>
                                                        </Link>
                                                        <Link className='posts_item' to={`/hls/11`} exact={ true } onClick={() => scroll.scrollToTop()}>
                                                            <div className='posts_item_top'>
                                                                <img src={`${IMAGES}/banners/hls_image_04_05.jpeg`} />
                                                            </div>
                                                            <div className={`posts_item_bottom`}>
                                                                <h2>Медитации для быстрого отхода ко сну</h2>
                                                                <p className='excerpt'>Успокойте разум для быстрого отхода ко сну с помощью медитации под приятную музыку</p>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                </div>
                                            :
                                                null
                                            }
                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                    </div>
                </section>
            </section>
        </section>
    );
};